import gql from 'graphql-tag';

export const DELETE_BILL_MUTATION = gql`
  mutation DeleteBill($where: BillWhereUniqueInput!) {
    deleteBill(where: $where) {
      id
    }
  }
`;
